import React, { useContext } from 'react';
import { LoadingContext } from '../../components/context/LoadingContext';
import Slider from "react-slick";
import i18n from "i18next";
import { Link } from "gatsby"
import iconClock from "../../images/targetVacancies/iconClock.png";

import imgV1 from "../../images/targetVacancies/imgVacancie1.png"; //customer
import imgV2 from "../../images/targetVacancies/imgVacancie2.png"; //analyst - qa
import imgV3 from "../../images/targetVacancies/imgVacancie3.png"; //developer
import imgV4 from "../../images/targetVacancies/imgVacancie4.png"; //project manager - n.a
import imgV5 from "../../images/targetVacancies/imgVacancie5.png"; //architect - engineer


const TargetVacancies = ({workArray}) => {

  const { windowWidth } = useContext(LoadingContext);

  const getVacancyImage = (jobName) => {
    const lowercaseJobName = jobName.toLowerCase(); // Convertir el nombre de la vacante a minúsculas para hacer coincidencias sin importar mayúsculas o minúsculas
  
    if (lowercaseJobName.includes("customer")) {
      return imgV1;
    } else if (lowercaseJobName.includes("analyst") || lowercaseJobName.includes("analista") || lowercaseJobName.includes("qa")) {
      return imgV2;
    } else if (lowercaseJobName.includes("developer") || lowercaseJobName.includes("dev") || lowercaseJobName.includes("desarrollador")) {
      return imgV3;
    } else if (lowercaseJobName.includes("project") || lowercaseJobName.includes("manager")) {
      return imgV4;
    } else if (
      lowercaseJobName.includes("architect") ||
      lowercaseJobName.includes("engineer") ||
      lowercaseJobName.includes("arquitecto") ||
      lowercaseJobName.includes("ingeniero")
    ) {
      return imgV5;
    } else {
      return imgV4;
    }
  };

  return (
    
              <div className={windowWidth > 1700 ? "desktop:flex desktop:flex-wrap pt-10 gap-auto2" : "desktop:flex desktop:flex-wrap pt-10 gap-auto"}>
                { windowWidth >= 1025 ?
                      <>{ windowWidth >= 1025  && windowWidth <= 1700 ? <>
                      {  workArray.map((job, i) => {
                         const vacancyImage = getVacancyImage(job.name);
                return (
              <div className={windowWidth > 1700 ? "targetVacancyResponsive":"targetVacancy"} key={job.jobId}>
                <div className='targetWorkTitle'>
                   <p className='ubicationWork'>{job.ubication}</p>

                    <p className='timeWork flex'>
                    <img className='iconClock' src={iconClock}></img>
                    {i18n.t("pagejoinourteam.targetVacancies.timeCreated")} {job.timeCreated} 
                    <img className='ml-4 iconClock' src={iconClock}></img>
                    {i18n.t("pagejoinourteam.targetVacancies.timeLast")} {job.timeLast}
                    </p>

                    <img className='mt-4 mb-1' src={vacancyImage} alt="Vacancy" loading="lazy"/>

                   <p className='titleWork mt-5'>{job.name}</p>
                   <p className='typeWork mt-2 '>{job.time}</p>
                   </div>

                    <div className='contentDescriptionWork'>
                        <p className='descriptionWork'>
                        {job.description}
                        </p>
                    </div>
                    <Link to={`/open-position/${job.jobId}`}>
                    <button className='contentButtomApplyVacancie ml-auto' style={{alignSelf:'center'}}>
                        <p className='textButtomGetTouch'>{i18n.t("pagejoinourteam.targetVacancies.applynow")}</p>
                    </button>
                    </Link>

                </div>)
                 }) 
                 }
                </>:
                <>
                {  workArray.map((job, i) => {
                         const vacancyImage = getVacancyImage(job.name);

                    return (
                  <div className='targetVacancyResponsive ' key={job.jobId}>
                    <div className='targetWorkTitle'>
                      <p className='ubicationWork'>{job.ubication}</p>

                      <p className='timeWork flex'>
                      <img className='iconClock' src={iconClock}></img>
                      {i18n.t("pagejoinourteam.targetVacancies.timeCreated")} {job.timeCreated} 
                      <img className='ml-4 iconClock' src={iconClock}></img>
                      {i18n.t("pagejoinourteam.targetVacancies.timeLast")} {job.timeLast}
                      </p>

                      <img className='mt-4 mb-1' src={vacancyImage} alt="Vacancy" loading="lazy"/>

                      <p className='titleWork mt-5'>{job.name}</p>
                      <p className='typeWork mt-2 '>{job.time}</p>
                      </div>

                        <div className='contentDescriptionWork'>
                            <p className='descriptionWork'>
                            {job.description}
                            </p>
                        </div>
                        <Link to={`/open-position/${job.jobId}`}>
                        <button className='contentButtomApplyVacancie ml-auto' style={{alignSelf:'center'}}>
                            <p className='textButtomGetTouch'>{i18n.t("pagejoinourteam.targetVacancies.applynow")}</p>
                        </button>
                        </Link>

                    </div>)
                    }) 
                    }
                    </>
                }</>:
                      <>
                      {  workArray.map((job, i) => {
                         const vacancyImage = getVacancyImage(job.name);

                return (
              <div className='targetWorkMobile ' key={job.jobId}>
                <div className='targetWorkTitle'>
                   <p className='ubicationWork'>{job.ubication}</p>

                   <p className='timeWork flex'>
                    <img className='iconClock' src={iconClock}></img>
                    {i18n.t("pagejoinourteam.targetVacancies.timeCreated")} {job.timeCreated} 
                    <img className='ml-4 iconClock' src={iconClock}></img>
                    {i18n.t("pagejoinourteam.targetVacancies.timeLast")} {job.timeLast}
                    </p>

                    <img className='mt-4 mb-1' src={vacancyImage} alt="Vacancy" loading="lazy" />

                   <p className='titleWork mt-5'>{job.name}</p>
                   <p className='typeWork mt-2 '>{job.time}</p>
                   </div>

                    <div className='contentDescriptionWork'>
                        <p className='descriptionWork'>
                        {job.description}
                        </p>
                    </div>
                    <Link to={`/open-position/${job.jobId}`}>
                    <button className='contentButtomApplyVacancie ml-auto' style={{alignSelf:'center'}}>
                        <p className='textButtomGetTouch'>{i18n.t("pagejoinourteam.targetVacancies.applynow")}</p>
                    </button>
                    </Link>

                </div>)
                 }) 
                 }
                      </>
                }
              
              </div>
  );
};

export default TargetVacancies;